interface Props {
  imagemUrl?: string | null;
  children: React.ReactNode;
}

/**
 * Fundo desfocado + escurecido que cobre a tela inteira em todas as etapas.
 * - Se houver imagem: usa ela como background, blur 24px, overlay primary-900/60
 * - Sem imagem: gradiente primary-600 → primary-400
 */
export default function FundoRifa({ imagemUrl, children }: Props) {
  return (
    <div className="relative min-h-screen">
      {/* Camada de fundo — fixa, coberta pela imagem ou gradiente */}
      {imagemUrl ? (
        <>
          <img
            src={imagemUrl}
            alt=""
            aria-hidden
            className="fixed inset-0 z-0 h-full w-full object-cover object-center"
            style={{ filter: 'blur(24px)', transform: 'scale(1.1)' }}
            loading="lazy"
            decoding="async"
          />
          <div className="fixed inset-0 z-0 bg-primary-900/60" />
        </>
      ) : (
        <div className="fixed inset-0 z-0 bg-gradient-to-br from-primary-600 via-primary-500 to-primary-400" />
      )}

      {/* Conteúdo acima do fundo */}
      <div className="relative z-10 min-h-screen">
        {children}
      </div>
    </div>
  );
}